import request from '@/utils/request'
//社区分类
export function cate(data) {
    return request({
        url:"/api/post/cate",
        method: 'post',
        params: data
    })
}
//帖子列表
export function home(data) {
    return request({
        url:"/api/v2/post/home",
        method: 'post',
        params: data
    })
}
//发帖
export function save(data) {
    return request({
        url:"/api/post/save",
        method: 'post',
        params: data
    })
}
//点赞
export function praise(data) {
    return request({
        url:"/api/praise/save",
        method: 'post',
        params: data
    })
}
//取消点赞
export function praiseDelete(data) {
    return request({
        url:"/api/praise/delete",
        method: 'post',
        params: data
    })
}
//判断是否点赞
export function check(data) {
    return request({
        url:"/api/praise/check",
        method: 'post',
        params: data
    })
}
//评论列表
export function comment(data) {
    return request({
        url:"/api/comment/index",
        method: 'post',
        params: data
    })
}
//帖子收藏
export function collect(data) {
    return request({
        url:"/api/collect/save",
        method: 'post',
        params: data
    })
}
//帖子取消收藏
export function collectDelete(data) {
    return request({
        url:"/api/collect/delete",
        method: 'post',
        params: data
    })
}
//帖子查询是否收藏
export function collectCheck(data) {
    return request({
        url:"/api/collect/check",
        method: 'post',
        params: data
    })
}
//用户是否已经关注
export function followivew(data) {
    return request({
        url:"/api/follow/check",
        method: 'post',
        params: data
    })
}
//关注用户
export function FocusOnTheUser(data) {
    return request({
        url:"/api/follow/save",
        method: 'post',
        params: data
    })
}
//取消关注用户
export function cancelDS(data) {
    return request({
        url:"/api/follow/delete",
        method: 'post',
        params: data
    })
}
//图片帖子发布
export function Addrelease(data) {
    return request({
        headers: { 'Content-Type':'multipart/form-data' },
        url:"/upload/api/post/save",
        method: 'post',
        data: data
    })
}
//观看任务
export function originaltaks(data){
    return request({
        url:'api/original/view',
        method:'post',
        params: data
    })
}
//帖子详情
export function details(data){
    return request({
        url:'api/post/details',
        method:'post',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/api/commonapi.js